import React, { type SyntheticEvent } from 'react';
import { styled } from '@compiled/react';

import type { UIAnalyticsEvent } from '@atlaskit/analytics-next';
import Button from '@atlaskit/button';
import CheckIcon from '@atlaskit/icon/core/migration/check-mark--check';
import CrossIcon from '@atlaskit/icon/core/migration/close--cross';

import { token } from '@atlaskit/tokens';

import { borderRadius, gridSize } from '@atlassian/jira-common-styles/src/main.tsx';
import { useIntl } from '@atlassian/jira-intl';
import messages from './messages.tsx';

export type Props = {
	isConfirmDisabled: boolean;
	onCancel: (arg1: UIAnalyticsEvent) => void;
	onConfirm: (arg1: UIAnalyticsEvent) => void;
};

export const ActionButtons = (props: Props) => {
	const { formatMessage } = useIntl();

	const handleCancel = (event: SyntheticEvent<HTMLElement>, analyticsEvent: UIAnalyticsEvent) => {
		props.onCancel(analyticsEvent);
	};

	const handleConfirm = (event: SyntheticEvent<HTMLElement>, analyticsEvent: UIAnalyticsEvent) => {
		props.onConfirm(analyticsEvent);
	};

	return (
		<Wrapper>
			<ButtonWrapper>
				<Button
					isDisabled={props.isConfirmDisabled}
					onClick={handleConfirm}
					iconBefore={<CheckIcon label={formatMessage(messages.confirm)} LEGACY_size="small" />}
					testId="issue-field-cmdb-object.ui.action-buttons.button-confirm"
					interactionName="auto-generated.issue-field-cmdb-object.ui.action-buttons.button-confirm.button"
				/>
			</ButtonWrapper>
			<ButtonWrapper>
				<Button
					onClick={handleCancel}
					iconBefore={<CrossIcon label={formatMessage(messages.cancel)} LEGACY_size="small" />}
					testId="issue-field-cmdb-object.ui.action-buttons.button-cancel"
					interactionName="auto-generated.issue-field-cmdb-object.ui.action-buttons.button-cancel.button1"
				/>
			</ButtonWrapper>
		</Wrapper>
	);
};

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const Wrapper = styled.div({
	display: 'flex',
	marginTop: 0,
	marginBottom: 0,
	marginLeft: token('space.negative.025'),
	marginRight: token('space.negative.025'),
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const ButtonWrapper = styled.div({
	boxShadow: token('elevation.shadow.raised'),

	backgroundColor: token('elevation.surface.raised'),
	marginTop: token('space.025'),
	marginRight: token('space.025'),
	marginBottom: token('space.025'),
	marginLeft: token('space.025'),
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	borderRadius: `${borderRadius}px`,
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
	button: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
		width: `${gridSize * 4}px`,
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
		height: `${gridSize * 4}px`,
	},
});
